// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Jj4Q","colBig":"styles_colBig__1QNYN","colSmall":"styles_colSmall__2KSjG","shopifyNameWrapper":"styles_shopifyNameWrapper__28tIu"};